export const HUMAN_RESOURCE_FIELD_OTHER = "OTHER";
export const HUMAN_RESOURCE_FIELD_KITCHEN = "KITCHEN";
export const HUMAN_RESOURCE_FIELD_MAINTENANCE = "MAINTENANCE";
export const HUMAN_RESOURCE_FIELD_DELIVERY = "DELIVERY";
export const HUMAN_RESOURCE_FIELD_WAREHOUSE = "WAREHOUSE";
export const HUMAN_RESOURCE_FIELD_OFFICE = "OFFICE";
export const HUMAN_RESOURCE_FIELD_INVENTORY = "INVENTORY";
export const HUMAN_RESOURCE_FIELD_COMMUNICATION = "COMMUNICATION";
export const HUMAN_RESOURCE_FIELD_SEASONAL = "SEASONAL";